import { render, staticRenderFns } from "./confirm_fork_modal.vue.js?vue&type=template&id=6e87389a&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./confirm_fork_modal.vue?vue&type=template&id=6e87389a&vue3"
import script from "./confirm_fork_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./confirm_fork_modal.vue?vue&type=script&lang=js&vue3"
export * from "./confirm_fork_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./confirm_fork_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports